module.exports = __webpack_public_path__ + "static/media/img01.d6afe139.png";